import { useState } from "react";
import { BlueHoverButton } from "../../../components/Inputs/BlueHoverButton";
import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import servSolicitacaoFiscalizacao from "../../../services/login/servSolicitacaoFiscalizacao";
import { style as modalStyle } from "../../../components/Loading/Loading";

const Analise = ({ pesquisar, record, setOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [openErrorWindow, setOpenErrorWindow] = useState(false);

  const handleCloseError = (event, reason) => {
    if (reason === 'clickaway') {
      setOpenErrorWindow(false);
    }

    setOpenErrorWindow(false);
  }

  const solicitarAnalise = async () => {
    if (record === null) {
      return;
    }

    try {
      setIsLoading(true);

      let id = record?.row?.Id || record?.Id;

      await servSolicitacaoFiscalizacao.SolicitarAnalise(id);

      setOpen(false);

      pesquisar();

      setIsLoading(false);

    } catch (err) {
      setIsLoading(false);

      setErrorMessage(err.response.data.Message);
      return setOpenErrorWindow(true);
    }
  }

  return (
    <div style={{ width: "100%", height: "200px" }}>
      <h4>
        Você deseja enviar a solicitação de fiscalização para análise? <br />
        Após o envio, a solicitação de fiscalização só poderá ser alterada em um momento de revisão ou reprovação.
      </h4>

      <div className="homologacao_consulta">
        <BlueHoverButton onClick={() => setOpen(false)} >Cancelar</BlueHoverButton>
        <BlueHoverButton onClick={solicitarAnalise} >Enviar</BlueHoverButton>
      </div>

      <Snackbar open={openErrorWindow} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleCloseError}>
        <Alert onClose={handleCloseError} severity="error" sx={{ width: '100%' }}>
          {errorMessage}
        </Alert>
      </Snackbar>

      <Modal open={isLoading}>
        <Box style={modalStyle}>
          <CircularProgress color="inherit" />
        </Box>
      </Modal>
    </div>
  )
}

export { Analise }